import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { DialogModule } from 'primeng/dialog';
import { DropdownModule } from 'primeng/dropdown';
import { InputTextModule } from 'primeng/inputtext';
import { ProductDbService } from '../../../../../services/productdb.service';

export interface DoctorInfo {
    doctorName: string;
    doctorMobile?: string;
    registrationNumber: string;
    hospitalClinicName: string;
    address1: string;
    address2: string;
    country: string;
    state: string;
    city: string;
    pincode: string;
}

@Component({
    selector: 'app-doctor-management-dialog',
    standalone: true,
    imports: [
        CommonModule,
        FormsModule,
        DialogModule,
        InputTextModule,
        DropdownModule,
    ],
    templateUrl: './doctor-management-dialog.component.html',
    styleUrl: './doctor-management-dialog.component.scss',
})
export class DoctorManagementDialogComponent implements OnInit {

    @Input() visible: boolean = false;
    @Output() visibleChange = new EventEmitter<boolean>();

    /** Initial / pre-filled doctor data */
    @Input() set initialData(data: Partial<DoctorInfo> | null) {
        if (data) {
            this.doctor = {
                doctorName: data.doctorName || '',
                doctorMobile: data.doctorMobile || '',
                registrationNumber: data.registrationNumber || '',
                hospitalClinicName: data.hospitalClinicName || '',
                address1: data.address1 || '',
                address2: data.address2 || '',
                country: data.country || '',
                state: data.state || '',
                city: data.city || '',
                pincode: data.pincode || '',
            };
            if (this.doctor.country) {
                this.onCountryChange(this.doctor.country);
            }
            if (this.doctor.state) {
                this.onStateChange(this.doctor.state);
            }
        }
    }

    /** Emits the filled DoctorInfo when user confirms */
    @Output() doctorSaved = new EventEmitter<DoctorInfo>();

    doctor: DoctorInfo = {
        doctorName: '',
        doctorMobile: '',
        registrationNumber: '',
        hospitalClinicName: '',
        address1: '',
        address2: '',
        country: '',
        state: '',
        city: '',
        pincode: '',
    };

    countries: { label: string; value: string }[] = [];
    states: { label: string; value: string }[] = [];
    cities: { label: string; value: string }[] = [];

    constructor(private productDbService: ProductDbService) {}

    ngOnInit(): void {
        this.loadCountries();
    }

    private loadCountries(): void {
        this.productDbService.getCountries().subscribe({
            next: (res) => {
                this.countries = (res.data || []).map((c: any) => ({
                    label: c.name,
                    value: String(c.id),
                }));
            },
            error: () => {
                // Silently ignore if API unavailable
            },
        });
    }

    onCountryChange(countryId: string): void {
        this.doctor.state = '';
        this.doctor.city = '';
        this.states = [];
        this.cities = [];
        if (!countryId) return;

        this.productDbService.getStates(Number(countryId)).subscribe({
            next: (res) => {
                this.states = (res.data || []).map((s: any) => ({
                    label: s.name,
                    value: String(s.id),
                }));
            },
        });
    }

    onStateChange(stateId: string): void {
        this.doctor.city = '';
        this.cities = [];
        if (!stateId) return;

        this.productDbService.getCities(Number(stateId)).subscribe({
            next: (res) => {
                this.cities = (res.data || []).map((c: any) => ({
                    label: c.name,
                    value: String(c.id),
                }));
            },
        });
    }

    save(): void {
        this.doctorSaved.emit({ ...this.doctor });
        this.close();
    }

    // clear(): void {
    //     this.doctor = {
    //         doctorName: '',
    //         doctorMobile: '',
    //         registrationNumber: '',
    //         hospitalClinicName: '',
    //         address1: '',
    //         address2: '',
    //         country: '',
    //         state: '',
    //         city: '',
    //         pincode: '',
    //     };
    //     this.states = [];
    //     this.cities = [];
    // }

    close(): void {
        this.visible = false;
        this.visibleChange.emit(false);
    }
}
